import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table";
import { Home } from "lucide-react";

export const OrderDetailsSkeleton = () => {
    return (
        <div className="min-h-screen bg-background animate-pulse">
            {/* Header Skeleton */}
            <header className="border-b bg-card">
                <div className="container mx-auto px-4 py-4">
                    <div className="mb-4 flex items-center space-x-2">
                        <Home className="h-4 w-4 text-muted-foreground" />
                        <Skeleton className="h-4 w-20" />
                        <Skeleton className="h-4 w-10" />
                        <Skeleton className="h-4 w-24" />
                    </div>

                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                        <div>
                            <Skeleton className="h-8 w-48 mb-2" />
                            <div className="flex items-center gap-2 flex-wrap">
                                <Skeleton className="h-6 w-24" />
                                <Skeleton className="h-6 w-32" />
                            </div>
                        </div>
                        <div className="flex gap-2">
                            <Skeleton className="h-10 w-24" />
                            <Skeleton className="h-10 w-32" />
                        </div>
                    </div>
                </div>
            </header>

            {/* Main Content Skeleton */}
            <main className="container mx-auto px-4 py-6 space-y-6">
                <div className="grid gap-6 md:grid-cols-2">
                    {/* Client Data Card Skeleton */}
                    <Card>
                        <CardHeader>
                            <CardTitle className="flex items-center gap-2">
                                <Skeleton className="h-5 w-5" />
                                <Skeleton className="h-6 w-32" />
                            </CardTitle>
                        </CardHeader>
                        <CardContent className="space-y-3">
                            {[...Array(6)].map((_, i) => (
                                <div key={i}>
                                    <Skeleton className="h-4 w-2/3 mb-1" />
                                    <Skeleton className="h-5 w-full" />
                                </div>
                            ))}
                        </CardContent>
                    </Card>

                    {/* Order Info Card Skeleton */}
                    <Card>
                        <CardHeader>
                            <CardTitle className="flex items-center gap-2">
                                <Skeleton className="h-5 w-5" />
                                <Skeleton className="h-6 w-40" />
                            </CardTitle>
                        </CardHeader>
                        <CardContent className="space-y-3">
                            {[...Array(3)].map((_, i) => (
                                <div key={i}>
                                    <Skeleton className="h-4 w-2/3 mb-1" />
                                    <Skeleton className="h-5 w-full" />
                                </div>
                            ))}
                        </CardContent>
                    </Card>
                </div>

                {/* Timeline Skeleton */}
                <Card>
                    <CardHeader><Skeleton className="h-6 w-1/4" /></CardHeader>
                    <CardContent>
                        <div className="flex items-center justify-between">
                            {[...Array(3)].map((_, i) => (
                                <div key={i} className="flex flex-col items-center flex-1">
                                    <Skeleton className="h-9 w-9 rounded-full mb-2" />
                                    <Skeleton className="h-4 w-16" />
                                </div>
                            ))}
                        </div>
                    </CardContent>
                </Card>

                {/* Products Table Skeleton */}
                <Card>
                    <CardHeader>
                        <CardTitle className="flex items-center gap-2">
                            <Skeleton className="h-5 w-5" />
                            <Skeleton className="h-6 w-48" />
                        </CardTitle>
                        <Skeleton className="h-4 w-1/3 mt-1" />
                    </CardHeader>
                    <CardContent>
                        <Table>
                            <TableHeader>
                                <TableRow>
                                    {[...Array(8)].map((_, i) => (
                                        <TableHead key={i}><Skeleton className="h-4 w-full" /></TableHead>
                                    ))}
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {[...Array(3)].map((_, i) => (
                                    <TableRow key={i}>
                                        {[...Array(8)].map((_, j) => (
                                            <TableCell key={j}><Skeleton className="h-5 w-full" /></TableCell>
                                        ))}
                                    </TableRow>
                                ))}
                                <TableRow className="bg-muted/50">
                                    <TableCell colSpan={7} className="text-right font-semibold"><Skeleton className="h-6 w-32 ml-auto" /></TableCell>
                                    <TableCell className="text-right font-bold text-lg"><Skeleton className="h-8 w-24 ml-auto" /></TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </CardContent>
                </Card>
            </main>
        </div>
    );
};
